<div class="top-menu">

  <a mat-button [matMenuTriggerFor]="currencyMenu" #currencyMenuTrigger="matMenuTrigger">
    {{currency.code}} {{currency.sign}}<mat-icon class="mat-icon-sm caret">arrow_drop_down</mat-icon>
  </a>
  <mat-menu #currencyMenu="matMenu" [overlapTrigger]="false" xPosition="before" class="app-dropdown">
    <span (mouseleave)="currencyMenuTrigger.closeMenu()">
      <button mat-menu-item *ngFor="let cur of currencies" (click)="changeCurrency(cur)">
        <span>{{cur.code}} {{cur.sign}}</span>
      </button>
    </span>
  </mat-menu>

  <a mat-button [matMenuTriggerFor]="countriesMenu" #countriesMenuTrigger="matMenuTrigger">
    <span *ngIf="!countries">Страна</span>
    <span *ngIf="countries">{{getCountryName(this.appService.Data.user.countryID)}}</span>
    <mat-icon class="mat-icon-sm caret">arrow_drop_down</mat-icon>
  </a>
    <mat-menu #countriesMenu="matMenu" [overlapTrigger]="false" xPosition="before" class="app-dropdown">
      <span (mouseleave)="countriesMenuTrigger.closeMenu()">
        <button mat-menu-item *ngFor="let countr of countries" (click)="changeCountry(countr)">
          <span>{{countr.countryRus}}</span>
        </button>
      </span>
    </mat-menu>

  <a mat-button [matMenuTriggerFor]="accountMenu" #accountMenuTrigger="matMenuTrigger">
    <mat-icon class="mat-icon-sm account-icon">person</mat-icon> <span fxShow="false" fxShow.gt-sm>Личный кабинет</span> <mat-icon class="mat-icon-sm caret">arrow_drop_down</mat-icon>
  </a>
  <mat-menu #accountMenu="matMenu" [overlapTrigger]="false" xPosition="before" class="app-dropdown account">
    <span (mouseleave)="accountMenuTrigger.closeMenu()">
      <div fxLayout="row" fxLayoutAlign="space-around center" class="user-info">
        <img src="assets/images/others/user.jpg" alt="user-image" width="50">
        <p>{{data.user.vUserName}}</p>
      </div>
      <div class="divider"></div>
      <button mat-menu-item (click)="goToProfile()">
        <mat-icon class="mat-icon-sm">settings</mat-icon>
        <span>Ваши данные и заказы</span>
      </button>
      <div class="divider"></div>
      <a mat-menu-item *ngIf="data.user.iUserID == 2121" routerLink="/sign-in">
        <mat-icon class="mat-icon-sm">power_settings_new</mat-icon>
        <span>Вход</span>
      </a>
      <button mat-menu-item *ngIf="data.user.iUserID != 2121" (click)="logOut()">
        <mat-icon class="mat-icon-sm">power_settings_new</mat-icon>
        <span>Выход</span>
      </button>
    </span>
  </mat-menu>

</div>  
